import classNames from "classnames";
import { useState } from "react";
import { useRecoilValue } from "recoil";
import { Button } from "../../../components/buttons";
import { Select } from "../../../components/inputs";
import { endpoints } from "../../../constants/Endpoints";
import useData from "../../../hooks/useData";
import { allExams, selectedLanguage } from "../../../providers";
import { instance } from "../../../services/https/inceptors";
import { showToast } from "../../../utilities/toast";

const AddWorkBookModal = ({ subject, closeModal, course, setCourse }) => {
  const [workbook, setWorkBooks] = useState([]);
  const [selectedWorkBook, setSelectedWorkBook] = useState([]);
  const exams = useRecoilValue(allExams);
  const language = useRecoilValue(selectedLanguage);

  const {
    departments,
    subjects,
    selectedDepartment,
    selectedExam,
    selectedSubject,
    onDepartmentSelect,
    onExamSelect,
    onSubjectSelect,
  } = useData();

  const saveWorkBook = async () => {
    try {
      if (selectedWorkBook.length > 2) {
        showToast({
          type: "error",
          message: "Only two Workbooks can be added!",
        });

        return;
      }

      await instance.post(endpoints.addCoursesWorkBook, {
        workBooks: selectedWorkBook,
        subjectId: subject,
      });

      const courseClone = JSON.parse(JSON.stringify(course));
      courseClone.workBooks.push(...selectedWorkBook);
      setCourse(courseClone);

      showToast({ type: "success", message: "Successfully Added Workbook!" });
      closeModal();
    } catch (err) {
      console.log(err);
      showToast({ type: "error", message: err?.response?.data?.message });
    }
  };

  const selectWorkbook = (chapter) => {
    let clone = JSON.parse(JSON.stringify(selectedWorkBook));

    if (clone.some((ch) => ch._id === chapter._id)) {
      clone = clone.filter((chap) => chap._id !== chapter._id);
    } else clone.push(chapter);

    setSelectedWorkBook(clone);
  };

  const getSearchedWorkbook = async () => {
    let url = "";
    if (selectedExam) url += `?exam=${selectedExam}`;
    if (selectedDepartment) url += `&department=${selectedDepartment}`;
    if (selectedSubject) url += `&subject=${selectedSubject}`;

    const res = await instance.get(endpoints.getWorkbookBySearch + url);

    const result = res.data.filter(
      (element2) =>
        !course?.workBooks?.some((element1) => element1._id === element2._id)
    );

    setWorkBooks(result);
  };

  return (
    <div className="backdrop fade show" style={{ background: "white" }}>
      <div className="modal-dialog modal-dialog-scrollable modal-fullscreen">
        <div className="modal-content">
          <div className="modal-header">
            {<h5 className="text-2xl font-semibold">Select Workbook</h5>}

            <button type="button" className="btn-close" onClick={closeModal} />
          </div>

          <div className="modal-body">
            <div className="container mt-3">
              <div className="d-flex justify-content-center mt-2 gap-3">
                <div className="w-20">
                  <Select
                    label="Exams"
                    value={selectedExam}
                    onChange={onExamSelect}
                  >
                    {exams?.map((exam) => (
                      <option key={exam.code} value={exam._id}>
                        {exam.title}
                      </option>
                    ))}
                  </Select>
                </div>
                <div className="w-20">
                  <Select
                    label="Departments"
                    value={selectedDepartment}
                    onChange={onDepartmentSelect}
                  >
                    {departments?.map((depart) => (
                      <option key={depart.code} value={depart._id}>
                        {depart.title}
                      </option>
                    ))}
                  </Select>
                </div>
                <div className="w-20">
                  <Select
                    label="Subject"
                    value={selectedSubject}
                    onChange={onSubjectSelect}
                  >
                    {subjects?.map((subj) => (
                      <option key={subj.code} value={subj._id}>
                        {subj.title}
                      </option>
                    ))}
                  </Select>
                </div>
              </div>
              <div className="d-flex justify-content-end w-100">
                <Button onClick={getSearchedWorkbook} width={20}>
                  Search
                </Button>
              </div>

              <hr className="my-5" />

              {workbook.length ? (
                <div className="d-flex flex-column gap-3">
                  {workbook?.map((wb) => (
                    <div
                      onClick={() => selectWorkbook(wb)}
                      className={`each-chapter d-flex c-pointer w-100 rounded ${
                        selectedWorkBook.some(
                          (selected) => selected._id === wb._id
                        ) && "selected-chapter"
                      }`}
                    >
                      <div
                        className={classNames("w-50 text-center border-r", {
                          "!bg-red-200": !wb.name?.[language.value],
                        })}
                      >
                        {wb.name?.[language.value] ??
                          `Not available in ${language.label}`}
                      </div>
                      <div className="w-50 text-center">{wb.marks} Marks</div>
                    </div>
                  ))}
                </div>
              ) : (
                <div
                  style={{ marginTop: "10rem" }}
                  className="text-center fs-5"
                >
                  No Workbook Found!
                </div>
              )}
            </div>
          </div>

          <div className="modal-footer gap-4">
            <div className="selected-length">
              <span> Selected</span>: {selectedWorkBook.length}
            </div>

            <button
              type="button"
              className="px-3 py-2 rounded-md bg-green-700 text-white"
              onClick={saveWorkBook}
            >
              Proceed
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddWorkBookModal;
